import { PaymentCardCommonFormComponent } from 'features/payment-form/card-base-form/card-base-form.component';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { PaymentFormService } from '../payment-form.service';
import { Subject } from 'rxjs';
import { AuthorizeNetConfig, PAYMENT_TYPES } from 'services/payment/payment.interface';
import { PaymentForm } from 'features/payment-form/payment-form.interface';

@Component({
  selector: 'cm-authorize-net-form',
  templateUrl: '../card-base-form/card-base-form.component.html',
  styleUrls: ['../card-base-form/card-base-form.component.scss'],
})
export class AuthorizeNetFormComponent extends PaymentCardCommonFormComponent implements OnInit, OnDestroy {
  @Input() showError = false;
  @Input() paymentConfig: AuthorizeNetConfig;
  @Output() formChange = new EventEmitter<any>();
  @Output() displayError = new EventEmitter<any>();

  private subject$ = new Subject<PaymentForm | any>();

  paymentType = PAYMENT_TYPES.AUTHORIZE_NET;

  constructor(paymentService: PaymentFormService) {
    super(paymentService);
  }

  ngOnDestroy() {
    this.subject$.complete();
  }

  submitForm() {
    this.sendPaymentDataToAnet();
  }

  private sendPaymentDataToAnet() {
    const authData = {
      clientKey: this.paymentConfig.clientKey,
      apiLoginID: this.paymentConfig.apiLogin,
    };

    const { holderName, mappedCardValues } = this.mapCardValues(this.cardForm.getRawValue());
    const cardData = {
      cardNumber: mappedCardValues.cardNumber,
      month: mappedCardValues.expDate.substr(0, 2),
      year: mappedCardValues.expDate.substr(2),
      cardCode: mappedCardValues.cvv,
      fullName: holderName,
    };

    const secureData = {
      authData,
      cardData,
    };

    (window as any).Accept.dispatchData(secureData, this.responseHandler.bind(this));
  }

  getData$() {
    return this.subject$.asObservable();
  }

  private responseHandler(response) {
    if (response.messages.resultCode === 'Error') {
      return this.displayError.emit(response.messages.message.map(({ text }) => ({ validation: text })));
    } else {
      this.subject$.next({
        type: PAYMENT_TYPES.AUTHORIZE_NET,
        data: {
          ...response.opaqueData,
        },
      });
    }
  }
}
